import dotenv from "dotenv";
import path from "path";
import { fileURLToPath } from "url";

// Load environment variables BEFORE importing anything else.
// Load parent ../.env first (shared Laravel DB_* config), then local .env (overrides).
const __dirname = path.dirname(fileURLToPath(import.meta.url));
dotenv.config({ path: path.resolve(__dirname, "../.env") });
dotenv.config({ path: path.resolve(__dirname, ".env"), override: true });

// Now import the actual server
await import("./server.js");
